const seedPlayers = [
    {name: "Solid Snake", points: 55, id: 1, defaultPoints: 0},
    {name: "Ocelot", points: 5, id: 2, defaultPoints: 0},
    {name: "Otacon", points: 7, id: 3, defaultPoints: 0},
    {name: "Eva", points: 90, id: 4, defaultPoints: 0}
];

export default seedPlayers;